import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_REGISTRATION_LIST: string = typeCreatorV2(
  'RegistrationListReducer',
  'SetRegistrationList'
);
